import { createAction, props } from '@ngrx/store';

import { SortItem } from '@shared/interfaces/sort-item';

export const setTurnoverListSorting = createAction(
  '[TurnoverList] set TurnoverList sorting',
  props<{ propertyId: number; sorting: SortItem }>()
);

export const toggleTurnoverListAssignees = createAction(
  '[TurnoverList] toggle TurnoverList assignees',
  props<{ stepAssignees: boolean }>()
);

export const toggleTurnoverListSteps = createAction(
  '[TurnoverList] toggle TurnoverList steps',
  props<{ showSteps: boolean }>()
);

export const setWidgetsCollapseState = createAction(
  '[TurnoverList] setWidgetsCollapseState',
  props<{ collapsed: boolean; manually: boolean }>()
);

export const setListScrollState = createAction('[TurnoverList] setListScrollState', props<{ position: number }>());
